import {IAppState} from '../../state/AppState';

export const getIsDarkMode = (state: IAppState) => state.localSettings.darkMode;

export const getIsV2GameAdminFunctions = (state: IAppState) => true;
// state.localSettings.v2GamesAdminFunctions;
